import classnames from 'classnames';
import React from 'react';

import EnterFullscreenIcon from '../icons/EnterFullscreenIcon';
import ExitFullscreenIon from '../icons/ExitFullscreenIcon';

const CSS = require('./FullscreenButton.module.scss');

interface FullscreenButtonProps {
  fullscreen: boolean;
  onClick: (event) => void;
  className?: string;
}

function FullscreenButton({
  fullscreen,
  onClick,
  className,
}: FullscreenButtonProps) {
  return (
    <button
      className={classnames(CSS.FullscreenButton, className)}
      onClick={onClick}
    >
      {fullscreen && <ExitFullscreenIon className={CSS.FullscreenButtonIcon} />}
      {!fullscreen && (
        <EnterFullscreenIcon className={CSS.FullscreenButtonIcon} />
      )}
    </button>
  );
}

export default FullscreenButton;
